export const buildDetailedInformationRowReimbursement = function (tenantDataRow, tab) {
    const rrTab = tab.includes('proforma') ? 'proforma-rr-tab' : 'current-rr-tab';
    return {
        highlightable: true,
        isHighlighted(tabs, rowIdentifier) {
            const inputText = tabs['current-rr-tab'].tables['general-information'].rows[rowIdentifier].valueCells[1].value;
            return (inputText.trim() === 'Vacant' || inputText.trim() === 'vacant')
        },
        valueCells: [{ // Prorata Share - 0
            editable: false,
            tooltip: '= sq_ft / total_sq_ft',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const row = tabs[rrTab].tables['general-information'].rows[rowIdentifier];
                const propertySqFt = row.valueCells[2].value ? parseFloat(row.valueCells[2].value) : 0;
                if (propertySqFt === 0) {
                    return {internalValue: -1, displayValue: `-`};
                }

                const totalSqFt = tabs[rrTab].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] ? tabs[rrTab].tables['sumed-general-information'].rows['third-row'].valueCells[2].getComputedValue(tabs, rowIdentifier, precomputedValues)['internalValue'] : 0;
                let percent = 100.00;
                if (totalSqFt !== 0) {
                    percent = parseFloat(propertySqFt / totalSqFt * 100);
                }

                return {internalValue: percent, displayValue: `${percent.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`};
            },
        }, { // Lease Type - 1
            editable: false,
            tooltip: '= VLOOKUP(reimb_code, code:description, description)',
            getComputedValue(tabs, rowIdentifier) {
                const row = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
                if (row) {
                    const reimbCode = row.valueCells[2].value;
                    const reimbursementType = tabs[tab].tables['reimbursement-types'].rows[reimbCode - 1];
                    if (!reimbursementType) {
                        return {internalValue: '', displayValue: '-'};
                    }
                    const value = reimbursementType.valueCells[1].value;
                    return {internalValue: value, displayValue: value};
                }
                return {internalValue: '', displayValue: '-'};
            },
        }, { // Reimb Code - 2
            unit: '',
            type: 'number',
            editable: true,
            value: tab === 'proforma-reimbursement-tab' && tenantDataRow.PROFORMA_REIMB_CODE ? tenantDataRow.PROFORMA_REIMB_CODE : tenantDataRow.REIMB_CODE,
        }, { // Annual Taxes - 3
            editable: false,
            tooltip: '= annual_taxes_psf * sq_ft',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const sqFt = tabs[rrTab].tables['general-information'].rows[rowIdentifier].valueCells[2].value;
                const psf = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[4].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const value = parseFloat(psf * sqFt);
                if (!value) {
                    return {internalValue: 0, displayValue: '-'};
                }
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // PSF - 4
            editable: false,
            tooltip: '= VLOOKUP(reimb_code, code:real_estate_taxes, real_estate_taxes, FALSE)',
            getComputedValue(tabs, rowIdentifier) {
                const row = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
                if (row) {
                    const reimbCode = row.valueCells[2].value;
                    const reimbursementType = tabs[tab].tables['reimbursement-types'].rows[reimbCode - 1];
                    if (!reimbursementType) {
                        return {internalValue: 0, displayValue: '-'};
                    }
                    const value = parseFloat(reimbursementType.valueCells[10].value);
                    const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                    return {internalValue: value, displayValue: displayValue};
                }
                return {internalValue: 0, displayValue: '-'};
            },
        }, { // Annual Insurance - 5
            editable: false,
            tooltip: '= annual_insurance_psf * sq_ft',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const sqFt = tabs[rrTab].tables['general-information'].rows[rowIdentifier].valueCells[2].value;
                const psf = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[6].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const value = parseFloat(psf * sqFt);
                if (!value) {
                    return {internalValue: 0, displayValue: '-'};
                }
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // PSF - 6
            editable: false,
            tooltip: '= VLOOKUP(reimb_code, code:real_estate_taxes, insurance, FALSE)',
            getComputedValue(tabs, rowIdentifier) {
                const row = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
                if (row) {
                    const reimbCode = row.valueCells[2].value;
                    const reimbursementType = tabs[tab].tables['reimbursement-types'].rows[reimbCode - 1];
                    if (!reimbursementType) {
                        return {internalValue: 0, displayValue: '-'};
                    }
                    const value = parseFloat(reimbursementType.valueCells[8].value);
                    const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                    return {internalValue: value, displayValue: displayValue};
                }
                return {internalValue: 0, displayValue: '-'};
            },
        }, { // Annual CAM - 7
            editable: false,
            tooltip: '= annual_cam_psf * sq_ft',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const sqFt = tabs[rrTab].tables['general-information'].rows[rowIdentifier].valueCells[2].value;
                const psf = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[8].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const value = parseFloat(psf * sqFt);
                if (!value) {
                    return {internalValue: 0, displayValue: '-'};
                }
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // PSF - 8
            editable: false,
            tooltip: '= VLOOKUP(reimb_code, code:real_estate_taxes, cam, FALSE)',
            getComputedValue(tabs, rowIdentifier) {
                const row = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
                if (row) {
                    const reimbCode = row.valueCells[2].value;
                    const reimbursementType = tabs[tab].tables['reimbursement-types'].rows[reimbCode - 1];
                    if (!reimbursementType) {
                        return {internalValue: 0, displayValue: '-'};
                    }
                    const value = parseFloat(reimbursementType.valueCells[4].value);
                    const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                    return {internalValue: value, displayValue: displayValue};
                }
                return {internalValue: 0, displayValue: '-'};
            },
        }, { // Annual Mgmt. Fee - 9
            editable: false,
            tooltip: '= annual_mgmt_fee_psf * sq_ft',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const sqFt = tabs[rrTab].tables['general-information'].rows[rowIdentifier].valueCells[2].value;
                const psf = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[10].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const value = parseFloat(psf * sqFt);
                if (!value) {
                    return {internalValue: 0, displayValue: '-'};
                }
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // PSF - 10
            editable: false,
            tooltip: '= VLOOKUP(reimb_code, code:real_estate_taxes, mgmt_fee, FALSE)',
            getComputedValue(tabs, rowIdentifier) {
                const row = tabs[tab].tables['detailed-information'].rows[rowIdentifier];
                if (row) {
                    const reimbCode = row.valueCells[2].value;
                    const reimbursementType = tabs[tab].tables['reimbursement-types'].rows[reimbCode - 1];
                    if (!reimbursementType) {
                        return {internalValue: 0, displayValue: '-'};
                    }
                    const value = parseFloat(reimbursementType.valueCells[6].value);
                    const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                    return {internalValue: value, displayValue: displayValue};
                }
                return {internalValue: 0, displayValue: '-'};
            },
        }, { // Annual Other - 11
            unit: '$',
            type: 'number',
            editable: true,
            forceStatic: tab === 'proforma-reimbursement-tab',
            value: tenantDataRow.REIMB_ANNUAL_OTHER
        }, { // PSF - 12
            editable: false,
            tooltip: '= annual_other / sq_ft',
            getComputedValue(tabs, rowIdentifier) {
                const sqFt = tabs[rrTab].tables['general-information'].rows[rowIdentifier].valueCells[2].value;
                const annualOther = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[11].value;
                const value = parseFloat(annualOther / sqFt);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Annual Total - 13
            editable: false,
            tooltip: '= annual_taxes + annual_insurance + annual_cam + annual_mgmt_fee + annual_other',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const cells = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells;
                const sumColumnsIndexes = [3, 5, 7, 9, 11];
                let sum = 0;
                sumColumnsIndexes.map((colIndex) => {
                    if (cells[colIndex].editable) {
                        if (cells[colIndex].value) {
                            sum += parseFloat(cells[colIndex].value);
                        }
                    } else {
                        sum += parseFloat(cells[colIndex].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue)
                    }
                });
                const value = parseFloat(sum || 0);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // PSF - 14
            editable: false,
            tooltip: '= annual_total / sq_ft',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const sqFt = tabs[rrTab].tables['general-information'].rows[rowIdentifier].valueCells[2].value;
                const annualTotal = tabs[tab].tables['detailed-information'].rows[rowIdentifier].valueCells[13].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const value = parseFloat(annualTotal / sqFt);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Notes - 15
            unit: '',
            editable: true,
            forceStatic: tab === 'proforma-reimbursement-tab',
            value: tenantDataRow.REIMB_NOTES
        }, { // Empty - 16
            editable: false,
            empty: true,
            hidden: tab === 'proforma-reimbursement-tab',
            getComputedValue() {
                return {internalValue: '', displayValue: ''};
            },
        }, { // Annual RET - 17
            editable: false,
            hidden: tab === 'proforma-reimbursement-tab',
            tooltip: '= monthly_ret * 12',
            getComputedValue(tabs, rowIdentifier) {
                const monthlyRet = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[28].value;
                const value = parseFloat(monthlyRet * 12);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // PSF - 18
            editable: false,
            hidden: tab === 'proforma-reimbursement-tab',
            tooltip: '= annual_ret / sq_ft',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const sqFt = tabs['current-rr-tab'].tables['general-information'].rows[rowIdentifier].valueCells[2].value;
                const annualRet = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[17].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const value = parseFloat(annualRet / sqFt);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Annual INS - 19
            editable: false,
            hidden: tab === 'proforma-reimbursement-tab',
            tooltip: '= monthly_ins * 12',
            getComputedValue(tabs, rowIdentifier) {
                const monthlyIns = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[30].value;
                const value = parseFloat(monthlyIns * 12);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // PSF - 20
            editable: false,
            hidden: tab === 'proforma-reimbursement-tab',
            tooltip: '= annual_ins / sq_ft',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const sqFt = tabs['current-rr-tab'].tables['general-information'].rows[rowIdentifier].valueCells[2].value;
                const annualIns = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[19].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const value = parseFloat(annualIns / sqFt);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Annual CAM - 21
            editable: false,
            hidden: tab === 'proforma-reimbursement-tab',
            tooltip: '= monthly_cam * 12',
            getComputedValue(tabs, rowIdentifier) {
                const monthlyCam = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[32].value;
                const value = parseFloat(monthlyCam * 12);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString()}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // PSF - 22
            editable: false,
            hidden: tab === 'proforma-reimbursement-tab',
            tooltip: '= annual_cam / sq_ft',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const sqFt = tabs['current-rr-tab'].tables['general-information'].rows[rowIdentifier].valueCells[2].value;
                const annualCam = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[21].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const value = parseFloat(annualCam / sqFt);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Annual Other - 23
            unit: '$',
            type: 'number',
            editable: true,
            hidden: tab === 'proforma-reimbursement-tab',
            value: tenantDataRow.REIMB_ANNUAL_OTHER_1,
        }, { // PSF - 24
            editable: false,
            hidden: tab === 'proforma-reimbursement-tab',
            tooltip: '= annual_other / sq_ft',
            getComputedValue(tabs, rowIdentifier) {
                const sqFt = tabs['current-rr-tab'].tables['general-information'].rows[rowIdentifier].valueCells[2].value;
                const annualOther = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[23].value;
                const value = parseFloat(annualOther / sqFt);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Collecting Annual Total - 25
            editable: false,
            hidden: tab === 'proforma-reimbursement-tab',
            tooltip: '= annual_ret + annual_ins + annual_cam + annual_other',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const annualRet = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[17].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const annualIns = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[19].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const annualCam = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[21].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const annualOther = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[23].value;
                const value = parseFloat(annualRet) + parseFloat(annualIns) + parseFloat(annualCam) + parseFloat(annualOther);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // PSF - 26
            editable: false,
            hidden: tab === 'proforma-reimbursement-tab',
            tooltip: '= annual_total / sq_ft',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const sqFt = tabs['current-rr-tab'].tables['general-information'].rows[rowIdentifier].valueCells[2].value;
                const annualTotal = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[25].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const value = parseFloat(annualTotal / sqFt);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Empty - 27
            unit: '',
            editable: false,
            empty: true,
            hidden: tab === 'proforma-reimbursement-tab',
            getComputedValue() {
                return {internalValue: '', displayValue: ''};
            },
        }, { // Monthly RET - 28
            type: 'number',
            unit: '$',
            editable: true,
            hidden: tab === 'proforma-reimbursement-tab',
            value: tenantDataRow.REIMB_MONTHLY_RET
        }, { // PSF - 29
            editable: false,
            hidden: tab === 'proforma-reimbursement-tab',
            tooltip: 'monthly_ret / sq_ft',
            getComputedValue(tabs, rowIdentifier) {
                const sqFt = tabs['current-rr-tab'].tables['general-information'].rows[rowIdentifier].valueCells[2].value;
                const monthlyRet = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[28].value;
                const value = parseFloat(monthlyRet / sqFt);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Monthly INS - 30
            unit: '$',
            type: 'number',
            editable: true,
            hidden: tab === 'proforma-reimbursement-tab',
            value: tenantDataRow.REIMB_MONTHLY_INS,
        }, { // PSF - 31
            editable: false,
            hidden: tab === 'proforma-reimbursement-tab',
            tooltip: 'monthly_ins / sq_ft',
            getComputedValue(tabs, rowIdentifier) {
                const sqFt = tabs['current-rr-tab'].tables['general-information'].rows[rowIdentifier].valueCells[2].value;
                const monthlyIns = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[30].value;
                const value = parseFloat(monthlyIns / sqFt);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Monthly CAM - 32
            unit: '$',
            type: 'number',
            editable: true,
            hidden: tab === 'proforma-reimbursement-tab',
            value: tenantDataRow.REIMB_MONTHLY_CAM,
        }, { // PSF - 33
            editable: false,
            hidden: tab === 'proforma-reimbursement-tab',
            tooltip: 'monthly_cam / sq_ft',
            getComputedValue(tabs, rowIdentifier) {
                const sqFt = tabs['current-rr-tab'].tables['general-information'].rows[rowIdentifier].valueCells[2].value;
                const monthlyCam = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[32].value;
                const value = parseFloat(monthlyCam / sqFt);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Monthly Other - 34
            unit: '$',
            type: 'number',
            editable: true,
            hidden: tab === 'proforma-reimbursement-tab',
            value: tenantDataRow.REIMB_MONTHLY_OTHER,
        }, { // PSF - 35
            editable: false,
            hidden: tab === 'proforma-reimbursement-tab',
            tooltip: 'monthly_other / sq_ft',
            getComputedValue(tabs, rowIdentifier) {
                const sqFt = tabs['current-rr-tab'].tables['general-information'].rows[rowIdentifier].valueCells[2].value;
                const monthlyOther = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[34].value;
                const value = parseFloat(monthlyOther / sqFt);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Monthly Total - 36
            editable: false,
            hidden: tab === 'proforma-reimbursement-tab',
            tooltip: 'monthly_ret + monthly_ins + monthly_cam + monthly_other',
            getComputedValue(tabs, rowIdentifier) {
                const monthlyRet = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[28].value;
                const monthlyIns = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[30].value;
                const monthlyCam = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[32].value;
                const monthlyOther = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[34].value;
                const value = parseFloat(monthlyRet) + parseFloat(monthlyIns) + parseFloat(monthlyCam) + parseFloat(monthlyOther);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // PSF - 37
            editable: false,
            hidden: tab === 'proforma-reimbursement-tab',
            tooltip: 'monthly_total / sq_ft',
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const sqFt = tabs['current-rr-tab'].tables['general-information'].rows[rowIdentifier].valueCells[2].value;
                const monthlyTotal = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[36].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const value = parseFloat(monthlyTotal / sqFt);
                const displayValue = !value || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // leave ARCIMEDES_ROW_ID as the last but one
            type: 'string',
            hidden: true,
            value: tenantDataRow.ARCIMEDES_ROW_ID,
        }, { // leave TENANT_ROW_ID as the last one
            type: 'string',
            hidden: true,
            value: tenantDataRow.TENANT_ROW_ID || '0',
        },]
    }
};

export const detailedInformation = {
    hasNamesColumn: false,
    rows: {},
};
